export default __webpack_public_path__ + "static/media/cognitive.d71d11ed.png";